import React from "react";
import InputSearch from "./Component/Search/Search";
import PickColumn from "./Component/PickColumn/PickColumn";
import Filter from "./Component/Filter/Filter";
import Action from "./Component/Action/Action";
import { Sellers } from './Component/Utils/Utils';
import CreatedOn from './Component/Createdon/CreatedOn';
import AddGroup from './Component/Addgroup/Addgroup';
import {

  Container,
  Header,
  HeaderIconLeft,
  HeaderIconRight,
  HeaderTitle,
  TableBody,
  TableContainer,
  TableHeader,
  Title,
} from "./Component/TableComponent/Table";


export default function AddSellerProducts() {
  const RowHeader = [
    "ProductID",
    "Status",
    "Product Name",
    "Product Cateogories",
    "Product HSN Code",
    "Assigned to",
    "Tags",
    "actions",
  ];
  // const { rows, isLoading, error } = Usefetch_Get(
  //   "http://localhost:4000/Table"
  // );
  const path = "/admin-dashboard/view-seller/";

  return (
    <div>
      <Container>
        <Title message={'sdssd'} showImport={false}> Add Buyer</Title>
        <Header>
          <HeaderTitle>
            <HeaderIconLeft>
              <InputSearch />
              <PickColumn />
            </HeaderIconLeft>
            <HeaderIconRight>
              <Action />
              <Filter />
              <AddGroup />
              <CreatedOn />
            </HeaderIconRight>
          </HeaderTitle>
          <TableContainer>
            <TableHeader children={RowHeader} />
            <TableBody
              rows={Sellers}
              // isLoading={isLoading}
              // error={error}
              path={path}
            />
          </TableContainer>
        </Header>
      </Container>
    </div>
  );
}